import React from 'react'
import { Typography } from '@material-ui/core'

const Title = props => {
  return <Typography component='h2' variant='h5' gutterBottom>
    {props.children}
  </Typography>
}

export default Title